import React, { useState } from "react";
import { FaMale, FaFemale } from "react-icons/fa";

const ProfileSetup = () => {
  const [gender, setGender] = useState("male");
  return (
    <>
      <section className="auth-page-bg py-8 md:py-24 relative">
        <div className="container">
          <div className="flex items-center justify-center">
            <div className="max-w-[485px] w-full text-center">
              {/* Title and Subtitle */}
              <h1 className="web-h2 text-gray-950 mb-2">Set Up Your Profile</h1>
              <p className="text-gray-600 web-body-sm mb-8">
                Tell us about yourself to receive tailored predictions and
                remedies.
              </p>

              {/* Login Card Container */}
              <div className="bg-white p-[15px] md:p-[20px] rounded-[20px] shadow-[0px_1px_14px_RGBA(79,77,77,0.08)]">
                {/* Form Content */}
                <form className="flex flex-col gap-[15px] text-left">
                  {/* Name */}
                  <div className="flex-col flex gap-[8px]">
                    <label
                      htmlFor="name"
                      className="text-[15px] text-gray-950 semibold"
                    >
                      Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      className="custom-input"
                      placeholder="Arjun Malhotra"
                      required
                    />
                  </div>

                  {/* Gender */}
                  <div className="flex-col flex gap-[8px]">
                    <label className="text-[15px] text-gray-950 semibold">
                      Gender
                    </label>
                    <div className="grid grid-cols-2 gap-[10px]">
                      <button
                        type="button"
                        onClick={() => setGender("male")}
                        className={`h-[48px] rounded-[6px] border transition-colors medium text-[14px] flex items-center justify-center gap-2 ${
                          gender === "male"
                            ? "bg-[#020079] text-white border-[#020079]"
                            : "bg-secondary-50 text-gray-700 border-secondary-200"
                        }`}
                      >
                        <span className="text-[16px]">
                          <FaMale />
                        </span>{" "}
                        Male
                      </button>
                      <button
                        type="button"
                        onClick={() => setGender("female")}
                        className={`h-[48px] rounded-[6px] border transition-colors medium text-[14px] flex items-center justify-center gap-2 ${
                          gender === "female"
                            ? "bg-[#020079] text-white border-[#020079]"
                            : "bg-secondary-50 text-gray-700 border-secondary-200"
                        }`}
                      >
                        <span className="text-[16px]">
                          <FaFemale />
                        </span>
                        Female
                      </button>
                    </div>
                  </div>

                  {/* Date of Birth */}
                  <div className="flex-col flex gap-[8px]">
                    <label
                      htmlFor="dob"
                      className="text-[15px] text-gray-950 semibold"
                    >
                      Date of Birth
                    </label>
                    <div className="relative">
                      <input
                        type="date"
                        id="dob"
                        className="custom-input pr-10"
                        placeholder="Select Date of Birth"
                        required
                      />
                    </div>
                  </div>

                  {/* Time of Birth */}
                  <div className="flex-col flex gap-[8px]">
                    <label
                      htmlFor="tob"
                      className="text-[15px] text-gray-950 semibold"
                    >
                      Time of Birth
                    </label>
                    <div className="relative">
                      <input
                        type="time"
                        id="tob"
                        className="custom-input pr-10"
                        placeholder="Select Time of Birth"
                        required
                      />
                    </div>
                  </div>

                  {/* Place of Birth */}
                  <div className="flex-col flex gap-[8px]">
                    <label
                      htmlFor="pob"
                      className="text-[15px] text-gray-950 semibold"
                    >
                      Place of Birth
                    </label>
                    <input
                      type="text"
                      id="pob"
                      className="custom-input"
                      placeholder="Enter Place of Birth"
                      required
                    />
                  </div>

                  {/* Email */}
                  <div className="flex-col flex gap-[8px]">
                    <label
                      htmlFor="email"
                      className="text-[15px] text-gray-950 semibold"
                    >
                      Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      className="custom-input"
                      placeholder="Enter Email"
                    />
                  </div>

                  {/* Mobile */}
                  <div className="flex-col flex gap-[8px]">
                    <label
                      htmlFor="mobile"
                      className="text-[15px] text-gray-950 semibold"
                    >
                      Mobile
                    </label>
                    <input
                      type="tel"
                      id="mobile"
                      className="custom-input"
                      placeholder="98765 43210"
                    />
                  </div>

                  {/* Continue Button */}
                  <button
                    type="submit"
                    className="custom-btn custom-btn-primary w-full mt-[15px]"
                    onClick={() =>
                      document.getElementById("profileSetupModal").showModal()
                    }
                  >
                    Continue
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute top-0 left-0 hidden xl:block">
          <img src="/images/shape3.png" alt="shape" />
        </div>
        <div className="absolute bottom-0 right-0 hidden xl:block">
          <img src="/images/shape4.png" alt="shape" />
        </div>
      </section>

      <dialog id="profileSetupModal" className="modal">
        <div className="modal-box p-0">
          <div className="modal-body">
            <div className="profile-setup-des text-center flex flex-col gap-[15px] items-center">
              <figure className="m-0">
                <img src="/images/check.svg" alt="check" />
              </figure>
              <figcaption>
                <h3 className="web-h3 mb-2">You’re All Set! </h3>
                <p className="web-body-md text-gray-600 !leading-[1.5]">
                  Your profile is ready—start exploring your daily horoscope,
                  Kundli, and personalized guidance.
                </p>
                <button
                  className="custom-btn custom-btn-primary mt-[15px]"
                  onClick={() =>
                    document.getElementById("profileSetupModal").close()
                  }
                >
                  Go to Home
                </button>
              </figcaption>
            </div>
          </div>
        </div>
      </dialog>
    </>
  );
};

export default ProfileSetup;
